import AsymmetricEncryptionService from "../services/AsymmetricEncryptionService";

/**
 * AsymmetricEncryptionMixin
 * 
 * Global mixin that provides encryption/decryption methods to all Vue components
 * 
 * Methods available:
 * - this.$encryptForBackend(data) - Encrypt data to send to backend
 * - this.$decryptFromBackend(encryptedData) - Decrypt data received from backend
 */
export default {
    methods: {
        /**
         * Encrypt data for backend
         * Uses Pair 1 public key (frontend can only encrypt, not decrypt)
         * 
         * @param {string|object} data - Data to encrypt
         * @returns {string} Base64 encoded encrypted string
         */
        $encryptForBackend(data) {
            try {
                return AsymmetricEncryptionService.encryptForBackend(data);
            } catch (error) {
                console.error('Error encrypting data for backend:', error);
                throw error;
            }
        },

        /**
         * Decrypt data from backend
         * Uses Pair 2 private key (frontend can only decrypt, not encrypt)
         * 
         * @param {string} encryptedData - Base64 encoded encrypted string
         * @returns {string} Decrypted data
         */
        $decryptFromBackend(encryptedData) {
            try {
                return AsymmetricEncryptionService.decryptFromBackend(encryptedData);
            } catch (error) {
                console.error('Error decrypting data from backend:', error);
                throw error;
            }
        },

        /**
         * Decrypt and parse JSON from backend
         * Convenience method that decrypts and parses JSON in one call
         * 
         * @param {string} encryptedData - Base64 encoded encrypted string
         * @returns {object} Parsed JSON object
         */
        $decryptJsonFromBackend(encryptedData) {
            try {
                const decrypted = this.$decryptFromBackend(encryptedData);
                return JSON.parse(decrypted);
            } catch (error) {
                console.error('Error decrypting and parsing JSON from backend:', error);
                throw error;
            }
        }
    }
};

